import { QlfConfirmationDialog, useQlfTranslation } from '@qualifio/ui-commons';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCancelScheduleTemplate } from '../../hooks/use-templates';

interface CancelScheduleDialogProps {
  open: boolean;
  templateName?: string;
  onClose: () => void;
}

export function CancelScheduleDialog({ open, templateName, onClose }: CancelScheduleDialogProps) {
  const { t } = useTranslation();
  const { t: htmlT } = useQlfTranslation('translation');
  const { mutateAsync: cancelScheduleTemplate } = useCancelScheduleTemplate();

  const handleConfirm = useCallback(async () => {
    await cancelScheduleTemplate();
    onClose();
  }, [cancelScheduleTemplate, onClose]);

  const versionReference = useMemo(() => {
    if (templateName) {
      return t('editor.template.version.reference.withName', { name: templateName });
    }
    return t('editor.template.version.reference.thisVersion').toLowerCase();
  }, [templateName, t]);

  return (
    <QlfConfirmationDialog
      title={t('editor.template.version.schedule.cancel.title')}
      content={htmlT('editor.template.version.schedule.cancel.message', {
        versionReference,
      })}
      confirmButtonText={t('editor.template.version.schedule.cancel.confirm')}
      cancelButtonText={t('generic.actions.cancel')}
      onConfirm={handleConfirm}
      onClose={onClose}
      color="warning"
      confirmButtonColor="secondary"
      open={open}
    />
  );
}
